import React from 'react';
import cn from 'classnames';
import styles from './checkbox.module.scss';

import { AnswerKind } from '../../models/answer.model'

interface CheckboxPros {
	kind: AnswerKind | 'agreement'
	checked: boolean
}

export default function Checkbox({ kind, checked }:CheckboxPros) {
	return <div className={cn(styles[kind as string], { [styles.checked]: checked })}/>
}